type GroupedFilterValueProps = { [key: string]: string[] };

/**
 *
 * @param data - values to format
 *
 * @returns - formatted values with group appended to the value in format value$group
 * so that the items are filter param type aware
 */
export const formatGroupedFilterValues = (data: GroupedFilterValueProps) => {
  return Object.entries(data).flatMap(([group, values]) => {
    return values.map((value) => `${value}$${group}`);
  });
};
